import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { PredialService } from "../../servicios/servicio.index";
//import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-desglose-saldo',
  templateUrl: './desglose-saldo.component.html',
  styleUrls: ['./desglose-saldo.component.css']
})
export class DesgloseSaldoComponent implements OnInit {
//private wowSubscription: Subscription;
fecha = new Date();
master: any = {
  ClaveCatastral: "",
  NombrePropietario: "",
  UbicacionPredio: "",
  BimestreInicial: "",
  ImpuestoCorriente: "",
  ImpuestoRezago: "",
  DiferenciaCorriente: "",
  DiferenciaRezago: "",
  RecargoCorriente: "",
  RecargoRezago: "",
  EjecucionCorriente: "",
  EjecucionRezago: "",
  HonorariosCorriente: "",
  HonorariosRezago: "",
  BonificacionPago: "",
  BonificacionPensionado: "",
  Descuento: "",
  Ajuste: "",
  ImporteTotal: "",
  Terreno: "",
  Construccion: "",
  ValorCatastral: "",
  fecha_limite: ""
};
forma: any = { ...this.master };
year = new Date().getFullYear();

modal: any = {
  nombre:"",
  apellidos:"",
  correo:"",
  telefono:"",
  direccion:"",
  codigopostal:"",
  Card: "",
  CVV: "",
  mes: "01",
  year: this.year - 2000,
  type:"DB"
};
  
years: any[] = [];

constructor(
  public router: Router,
  private route: ActivatedRoute,
  private _predialService: PredialService,
 // private modalService: NgbModal
) {
  /*const navigation:any = this.router.getCurrentNavigation();
  const clave_catastral = navigation.extras.state
    ? navigation.extras.state.clave_catastral
    : 0;*/

  const navigation: any = this.router.getCurrentNavigation();
  const clave_catastral = navigation?.extras?.state?.clave_catastral
    || this.route.snapshot.queryParams['clave_catastral']
    || 0;

    
  for (let x = this.year; x <= this.year + 15; x++) {
    const obj: any = {
      year: x,
      value: x - 2000
    };
    this.years.push(obj);
  }

  this.buscar(clave_catastral);
}

ngOnInit() {

}

ngOnDestroy() {

}

buscar(clave_catastral:any) {
  console.log(clave_catastral)
  console.log(this.forma)
  this._predialService.getConsulta(clave_catastral).subscribe(
    data => {
      console.log(this.forma)
      this.forma = data.registro;
      console.log(data)
    },
    err => {}
  );
}

enviar(m:any) {
  m.show();
}
  pagarV2() {
   let datos_tarjeta;
    const tarjeta = this.modal.Card.slice(0,8);


   /* this._predialService.getInfoTarjeta(tarjeta).subscribe(data => {
      console.log(data)
        datos_tarjeta = data;
        if(datos_tarjeta.type == 'debit'){
          datos_tarjeta.type = 'DB';
        }else{
          datos_tarjeta.type = 'CR';
        }
*/

      const p3ds = {
        nombre:this.modal.nombre,
        apellidos:this.modal.apellidos,
        correo: this.modal.correo,
        telefono:this.modal.telefono,
        direccion:this.modal.direccion,
        codigopostal:this.modal.codigopostal,
        Card: this.modal.Card,
        SECURITY_CODE: this.modal.CVV,
        CANALPAGO: "PAGINA NLD",
        Expires: this.modal.mes + "/" + this.modal.year,
        ClaveCatastral: this.forma.ClaveCatastral,
        CardType: this.modal.Card.charAt(0) == "4" ? "VISA" : "MC",
        // CreditType: 'DB' //DB O CR
        CreditType: this.modal.type
      };
      console.log(p3ds)


    //  if(p3ds.CardType=="MC"){
        //alert("No se pudo realizar la Transacción, Se encuentra en Actualizacion.");
     
      //}else{
            this._predialService.proces3ds2(p3ds).subscribe(data => {
              console.log(data)
              const newWindow: any = window.open();
              newWindow.document.write(data);
              //  window.document.write(data);
              //  console.log(data)
            },
              err => { });
    //  }
      
     




     // })
   
  }
pagar() {
  /*
  this._predialService.getPdf(this.forma.ClaveCatastral).subscribe(
    data => {
    },
    err => {}
  );*/

  
  const p3ds= {
      Card: this.modal.Card,
      SECURITY_CODE: this.modal.CVV,
      CANALPAGO: "PAGINA NLD",
      Expires: this.modal.mes + "/" + this.modal.year,
      ClaveCatastral: this.forma.ClaveCatastral,
      CardType: this.modal.Card.charAt(0) == "4" ? "VISA" : "MC"
    };
    console.log(p3ds)
  this._predialService.proces3ds(p3ds).subscribe(
    data => {

      const newWindow:any = window.open();
      newWindow.document.write(data);
    },
    err => {}
  );
}
}
